const TOOL_ENDPOINTS = {
  getExistingHosts: '/.netlify/functions/getExistingHosts',
  getExistingQuestions: '/.netlify/functions/getExistingQuestions',
  getExistingGameModes: '/.netlify/functions/getExistingGameModes',
  getExistingQuestPacks: '/.netlify/functions/getExistingQuestPacks',
  getExistingGamePacks: '/.netlify/functions/getExistingGamePacks',
  saveHost: '/.netlify/functions/saveHost',
  updateHost: '/.netlify/functions/updateHost',
  saveQuestion: '/.netlify/functions/saveQuestion',
  updateQuestion: '/.netlify/functions/updateQuestion',
  saveQuestPack: '/.netlify/functions/saveQuestPack',
  updateQuestPack: '/.netlify/functions/updateQuestPack',
  saveGamePack: '/.netlify/functions/saveGamePack',
  updateGamePack: '/.netlify/functions/updateGamePack',
  saveGameMode: '/.netlify/functions/saveGameMode',
  updateGameMode: '/.netlify/functions/updateGameMode',
  getStudioAssets: '/.netlify/functions/getStudioAssets',
  saveStudioAsset: '/.netlify/functions/saveStudioAsset',
  updateStudioAsset: '/.netlify/functions/updateStudioAsset',
};

const LOCAL_ONLY_TOOLS = new Set(['update_scores', 'display_question', 'end_game']);

function parseToolArguments(rawArguments) {
  if (!rawArguments) {
    return {};
  }

  if (typeof rawArguments === 'object') {
    return rawArguments;
  }

  try {
    return JSON.parse(rawArguments);
  } catch (error) {
    return {
      __parse_error: 'Invalid tool arguments payload',
      raw: rawArguments,
    };
  }
}

export async function executeRealtimeTool(name, rawArguments) {
  const parsedArguments = parseToolArguments(rawArguments);

  if (parsedArguments.__parse_error) {
    return {
      success: false,
      tool: name,
      error: parsedArguments.__parse_error,
    };
  }

  if (LOCAL_ONLY_TOOLS.has(name)) {
    return {
      success: true,
      handled_locally: true,
      tool: name,
      arguments: parsedArguments,
    };
  }

  const endpoint = TOOL_ENDPOINTS[name];
  if (!endpoint) {
    return {
      success: false,
      tool: name,
      error: `Unsupported tool: ${name}`,
    };
  }

  const token = localStorage.getItem('auth_token');
  if (!token) {
    return {
      success: false,
      tool: name,
      error: 'Missing auth token',
    };
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(parsedArguments),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    return {
      success: false,
      tool: name,
      error: payload.error || payload.message || `Tool call failed with status ${response.status}`,
    };
  }

  return {
    success: true,
    tool: name,
    ...payload,
  };
}

export default executeRealtimeTool;
